import ImageAndLogout from "./ImageAndLogout";
import Logotipo from "./Logotipo";
import Menu from "./Menu";
const Sidebar = ({ sidebar, user }) => {
  return (
    <div
      className={`
            fixed lg:static w-[80%] md:w-[40%] lg:w-full top-0 z-50 bg-white transition-all
            ${sidebar ? "-left-0" : "-left-full"}
            w-full h-full xs:overflow-y-scroll col-span-1 p-8 border-r
        `}
    >
      <Logotipo />

      <div className="flex flex-col justify-between h-[600px] md:h-[780px] lg:h-[700px]">
        <Menu user={user} />
        <ImageAndLogout />
      </div>
    </div>
  );
};
export default Sidebar;